import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../utils/context/auth-context";

export function AuthGuard({ children }: { children: JSX.Element }) {
  const navigate = useNavigate();
  const { auth } = useAuth();

  useEffect(() => {
    if (!auth) {
      navigate("/auth/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  return auth ? children : <></>;
}
export function ReversGuard({ children }: { children: JSX.Element }) {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const location = useLocation();

  // Get authorization redirect
  const queryParams = new URLSearchParams(location.search);
  const platform = queryParams.get("platform");
  const clientId = queryParams.get("client_id");

  if (platform === "pc" && clientId && auth) {
    navigate(`/authorize?platform=${platform}&client_id=${clientId}`, {
      replace: true,
    });
  } else if (auth) {
    navigate("/profile", { replace: true });
  }

  // if (authToken) return <Navigate to="/profile" replace />;
  // useEffect(() => {
  //   if (auth) {
  //     navigate("/profile");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [auth]);

  return !auth ? children : <></>;
}